import { array, object } from "prop-types"
import { css } from "@emotion/react"

import EventListing from "source/calendar/list/EventListing"
import { Subheading } from "@planningcenter/doxy-web"

ListDay.propTypes = { day: object, events: array }
export default function ListDay({ day, events }) {
  const eventList = css`
    display: flex;
    flex-direction: column;
    gap: 20px;
    list-style: none;
    margin: 0;
    padding: 0;
  `

  return (
    <>
      <div className="my-3" data-date={day.format("YYYY-MM-DD")}>
        <Subheading level={2} text={day.format("dddd, MMM D")} />
      </div>

      <ul css={eventList}>
        {events.map((event) => {
          const signupsAvailable = event.registrationUrl?.canRegister
          const eventLocation =
            event.campus ||
            event.location?.name ||
            event.location?.formattedAddress

          return (
            <EventListing
              key={event.id}
              eventDate={day}
              eventId={event.id}
              eventTitle={event.name}
              eventRecurrence={event.recurrenceDescription}
              eventLocation={eventLocation}
              eventTime={event.eventTime}
              showPagePath={event.showPagePath}
              signupsAvailable={signupsAvailable}
            />
          )
        })}
      </ul>
    </>
  )
}
